import {createApi} from '@reduxjs/toolkit/query/react';
import {customBaseQueryWithCaptcha} from '~/common/rtk-query/queries';

export const api = createApi({
  reducerPath: 'viewInvitationApi',
  baseQuery: customBaseQueryWithCaptcha,
  tagTypes: ['Event', 'Photo'],
  endpoints: () => ({}),
});
